/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ reason: NonNullable<unknown>, name: NonNullable<unknown>, date: NonNullable<unknown> }} Einvoice_Skipped_Card_ByInputs */

const vi_einvoice_skipped_card_by = /** @type {(inputs: Einvoice_Skipped_Card_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Không xuất: ${i?.reason} — ${i?.name} · ${i?.date}`)
};

/**

* @param {Einvoice_Skipped_Card_ByInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_skipped_card_by = /** @type {((inputs: Einvoice_Skipped_Card_ByInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Skipped_Card_ByInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_skipped_card_by(inputs)
});